export default {
    Title: "Euneos CMS",
    NotActive: "Account not activated",
    NotActiveContact:
        "Your account has not been approved yet by an administrator. If you believe this is a mistake, please contact them.",
    Home: {
        Title: "Welcome to Euneos CMS",
        WhatIsACMS: "What is a CMS?",
        CMSExplanation: `A CMS (Content Management System) is a place where you can modify the content delivered by your website.
            This means that you can create new articles, campaigns, courses, and much more right here.`,
        WhatContent: "What content can I manage?",
        ContentExplanation: `You can manage courses, page contents, campaigns, blog articles and assets. Find the links below to help you.`,
    },
    Login: {
        Title: "Welcome",
        SubTitle: "Please log in",
        Email: "Email",
        Password: "Password",
        LogIn: "Log in",
    },
    Courses: {
        Title: "Courses",
        Name: "Name",
        ShortDescription: "Short description",
        ShortPromo: "Short promo",
        Description: "Description",
        Price: "Price",
        Language: "Language",
        Picture: "Picture",
        DirectSignUp: "Direct sign up",
        DirectSignUpExplanation: `This means that participants can directly register for the course. This will also require them to pay upfront.
        If disabled, registrations will be sent to the admin dashboard where administrators can then take contact with them and finalize registration.`,
        Online: "Online course",
        OnlineExplanation:
            "Is this course online? If not, it is categorized as an on-premise course.",
        ChooseCourses: "Choose courses",
        ChooseCourse: "Choose course",
        Delete: "Delete course",
        AreYouSureDelete:
            "Are you sure you want to delete this courses? This cannot be reverted and any registration will be lost.",
        Category: "Category",
        Hidden: "Hidden",
    },
    Form: {
        FieldRequired: "This field is required",
        Delete: "Delete",
        Update: "Update",
        Save: "Save",
        DocumentSaved: "Document saved!",
        DocumentDeleted: "Document deleted!",
        Save: "Save",
        Create: "Create",
    },
    Blog: {
        Title: "Blog",
        BlogTitle: "Title",
        Picture: "Picture",
        Description: "Description",
        Content: "Content",
        Language: "Language",
        ChooseArticle: "Choose article",
        ChooseArticles: "Choose articles",
        Delete: "Delete article",
        AreYouSureDelete:
            "Are you sure you want to delete this article? This cannot be reverted.",
    },
    About: {
        Title: "About",
        PageTitle: "Title",
        Order: "Order",
        Page: "About main page",
        Pages: "About pages",
        Content: "Content",
    },
    HomePage: {
        Title: "Home",
        Page: "Home page",
        Content: "Content",
        MainPicture: "Main picture",
        TrendingCourses: "Trending courses",
        FeaturedArticle: "Featured article",
        Heading: "Heading",
    },
    Assets: {
        Title: "Assets",
        Add: "Add asset",
        Choose: "Choose from assets",
    },
    Categories: {
        Title: "Categories",
        Name: "Name",
        Description: "Description",
        Picture: "Picture",
    },
    NothingHereYet: "Nothing here yet",
    Create: "Create",
    Upload: "Upload",
    ChoosePicture: "Choose picture",
    CompleteAllFields: "Please complete all fields",
    Save: "Save",
    AreYouSure: "Are you sure?",
    AreYouSureYouWantToDoThis: "Are you sure you want to do this?",
    Yes: "Yes",
    No: "No",
    Cancel: "Cancel",
    Search: "Search",
    Choose: "Choose",
};
